const e = {
  name: "InnovationHeroes",
  dimensions: { width: 34, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 34.2 40" style="enable-background:new 0 0 34.2 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M18.1,3.6l5,5V12c0,3.3-2.7,6-6,6c-3.3,0-6-2.7-6-6v-1.4L18.1,3.6z M13.1,11.4V12c0,2.2,1.8,4,4,4
			c2.2,0,4-1.8,4-4V9.4l-3-3L13.1,11.4z"/>
		<path class="st0" d="M7.7,7.7C8.6,3.2,12.6,0,17.1,0c2.3,0,4.4,0.8,6,2.2c1.7,1.4,2.9,3.3,3.3,5.5l2.8,13.9l-0.6,0.4
			c-0.9,0.5-1.9,1-2.9,1.3l8.5,2.3L17.1,40L0,25.5l8.5-2.3c-1-0.4-2-0.8-2.9-1.3L5,21.5L7.7,7.7z M12.1,22.2v-3.8l1.4,0.7
			c2.2,1.1,4.9,1.1,7.1,0l1.4-0.7v3.8c1.7-0.4,3.3-1,4.9-1.8L24.5,8.1c-0.4-1.8-1.3-3.3-2.6-4.4c-1.3-1.1-3-1.7-4.8-1.7
			c-3.6,0-6.7,2.5-7.4,6.1L7.2,20.5C8.8,21.3,10.4,21.8,12.1,22.2z M14.1,23.8l-9.9,2.7l12.9,10.9L30,26.5l-9.9-2.7v-2.3
			c-2,0.6-4,0.6-6,0V23.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as InnovationHeroes
};
